$(document).ready(function () {
    $(".colecao-referencias").slick({
        "slidesToShow": 4,
        "slidesToScroll": 4,
        dots: true,
        arrows: false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    "slidesToShow": 1,
                    "slidesToScroll": 1,
                }
            }
        ]
    });
});